export const logError = (e: Error, errorInfo?: any) => {
    ep.EpLogger?.logErrorWithExtendedStackTrace(e, errorInfo);

    // eslint-disable-next-line no-console
    console?.error(e);

    // passed by root saga on error
    if (errorInfo?.sagaStack) {
        // eslint-disable-next-line no-console
        console?.error(errorInfo.sagaStack);
    }
};
